<template>
  <div class="afterEval">
    <div class="list">
      <ul>
        <li>
          <div class="product" v-if="list">
            <div v-if="list && list.item_list && (list.item_list.length <= 1 && list.item_list.length > 0)" class="productBox">
              <img v-lazy="list.item_list[0].img_path">
              <div class="proContent">
                <b>{{list.item_list[0].name}}</b>
                <p>
                  <b>{{list.item_list[0].spec}}</b>
                </p>
              </div>
            </div>
            <div v-if="list && list.item_list && list.item_list.length > 1" class="productBox bestSellingSwiper" style="overflow: hidden;position:relative;">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, idx) of list.item_list" :key="idx">
                  <img v-lazy="item.img_path">
                </swiper-slide>
              </swiper>
            </div>
            <span class="totelPrice">
              <span class="price" v-if="totalmoney">
                {{String(parseFloat(totalmoney).toFixed(2)).slice(0, String(parseFloat(totalmoney).toFixed(2)).indexOf('.'))}}
                <i>
                 {{String(parseFloat(totalmoney).toFixed(2)).slice(String(parseFloat(totalmoney).toFixed(2)).indexOf('.'), String(parseFloat(totalmoney).toFixed(2)).length)}}
                </i>
              </span>
              <b>共{{list.nums}}件</b>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <article>
      <textarea v-model="textinput" name="" id="afterEval" placeholder="请描述您对本次服务的看法"></textarea>
      <p>{{textNum}}/200</p>
      <div class="evalPhotoBox">
        <!--<ul class="evalPhoto">-->
        <!--<li><img src="../../assets/images/add.png"></li>-->
        <!--</ul>-->
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="6"
          preview-size="75"
        />
        <span>最多上传6张图片</span>
      </div>
    </article>
    <div class="contact" style="margin-bottom: 0.1rem">
      <div class="contactTitle">
        <b>评分</b>
        <p>客观打分，有助于我们改进工作哦～</p>
      </div>
      <van-rate v-model="value" void-color="#eee" void-icon="star" :size="15" />
    </div>
    <footer class="footerIOS">
      <button class="btn" @click="submit">提交</button>
    </footer>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
// const OSS = require('ali-oss').Wrapper
export default {
  name: 'afterEvaluation',
  data () {
    return {
      totalmoney: 0,
      list: [],
      fileList: [],
      fileLen: null,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      textinput: '',
      textNum: 0,
      value: 5,
      imgpath: []
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'afterevaluation'})
    }
    this.list = []
    if (sessionStorage.getItem('evaluate_after_product')) {
      this.list = JSON.parse(sessionStorage.getItem('evaluate_after_product'))
      this.list.item_list.map(item => {
        this.totalmoney = this.totalmoney + parseFloat(item.back_price)
      })
      console.log(this.list)
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    textinput (n) {
      if (n.length > 200) {
        this.textNum = 200
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 200)
      console.log(n.length)
    }
  },
  methods: {
    afterRead (file, fn) {
      console.log(file)
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      const url = this.ossUrl
      var that = this
      customRequestAjax(url).then(async res => {
        if (res.data.code === 200) {
          const {
            accessid,
            host,
            policy,
            signature,
            dir
          } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + '.png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            //添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
          that.$axios.post(host, fd, config).then(res => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.ossImgUrl + `${dir}${str}`
              var img = `${dir}${str}`.replace('Uploads/', '')
              that.imgpath.push(img)
              that.fileLen++
              if (that.fileLen >= that.fileList.length) {
                if (typeof fn == 'function') {
                  fn()
                }
              } else {
                that.afterRead(that.fileList[that.fileLen], function () {
                  that.submitAxios()
                })
              }
            }
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function(theBlob, fileName){
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    submit: function () {
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.imgpath = []
      var that = this
      if (that.fileLen < that.fileList.length) {
        that.afterRead(that.fileList[that.fileLen], function () {
          that.submitAxios()
        })
      } else {
        that.submitAxios()
      }
    },
    submitAxios: function () {
      var url = 'Wxmall/Comment/addCommentByReturn'
      var that = this
      this.$ckeckgraphic({
        content: that.textinput,
        images: that.imgpath.length > 0 ? that.imgpath.join() : '',
        callback: () => {
          var data = {
            refund_id: that.list.id,
            score: that.value,
            content: that.textinput,
            path1: that.imgpath[0] ? that.imgpath[0] : '',
            path2: that.imgpath[1] ? that.imgpath[1] : '',
            path3: that.imgpath[2] ? that.imgpath[2] : '',
            path4: that.imgpath[3] ? that.imgpath[3] : '',
            path5: that.imgpath[4] ? that.imgpath[4] : '',
            path6: that.imgpath[5] ? that.imgpath[5] : '',
          }
          customRequestAjax.post(url, data).then(res => {
            if (res.data.code === 200) {
              sessionStorage.removeItem('evaluate_after_product')
              that.$router.go(-1)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/footerSubmit";
  .list ul li p, .product{
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
  }
  .afterEval {
    .list {
      background: #fff;
      margin: 0.1rem 0.11rem 0;
      padding: 0.2rem 0.15rem;
      border-radius: 0.03rem;
      >ul {
        >li {
          background: #fff;
          >p {
            border-bottom: 1px solid #EFEFEF;
            padding-bottom: 0.1rem;
            span {
              display: block;
              b {
                display: block;
                font-weight: 400;
                color: #444444;
                font-size:0.12rem;
                float: left;
                &:last-of-type {
                  margin-left: 0.04rem;
                }
              }
            }
            i {
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              b{
                border-left: 1px solid #D8D8D8;
                margin-left: 0.06rem;
                padding-left: 0.07rem;
                display: flex;
                display: -o-flex;
                display: -webkit-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: center;
                -o-align-items: center;
                -webkit-align-items: center;
                -ms-align-items: center;
                -moz-align-items: center;
                img {
                  width:0.12rem;
                  height:0.12rem;
                }
              }
            }
          }
          .product {
            position: relative;
            .productBox {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -o-flex;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
              .proContent {
                margin-left: 0.07rem;
                margin-top: 0.08rem;
                flex: 1;
                -webkit-flex: 1;
                -moz-flex: 1;
                -ms-flex: 1;
                -o-flex: 1;
                >b {
                  font-size:0.13rem;
                  font-weight:400;
                  color:rgba(41,41,41,1);
                  line-height:0.18rem;
                  display: block;
                  margin-bottom: 0.05rem;
                }
                >p{
                  align-items: flex-start;
                  -moz-align-items: flex-start;
                  -ms-align-items: flex-start;
                  -webkit-align-items: flex-start;
                  -o-align-items: flex-start;
                  >b {
                    font-size:0.11rem;
                    font-weight:400;
                    color:rgba(108,108,108,1);
                    line-height:0.16rem;
                    display: block;
                  }
                }
              }
            }
            .totelPrice {
              position: absolute;
              right: -0.02rem;
              z-index: 10;
              opacity:0.85;
              height: 0.8rem;
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              flex-direction: column;
              -webkit-flex-direction: column;
              -o-flex-direction: column;
              -ms-flex-direction: column;
              -moz-flex-direction: column;
              justify-content: center;
              -webkit-justify-content: center;
              -o-justify-content: center;
              -ms-justify-content: center;
              -moz-justify-content: center;
              .price {
                display: flex;
                display: -webkit-flex;
                display: -o-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: flex-end;
                -webkit-align-items: flex-end;
                -o-align-items: flex-end;
                -ms-align-items: flex-end;
                -moz-align-items: flex-end;
                font-size: 0.14rem;
                font-weight:600;
                color:#222222;
                line-height:0.14rem;
                &:before {
                  content: '￥';
                  font-size:0.10rem;
                  font-weight:600;
                  line-height: 0.14rem;
                }
                i {
                  font-size: 0.11rem;
                  font-style: normal;
                  line-height: 0.14rem;
                }
              }
              >b {
                color: #908D8D;
                font-size: 0.11rem;
                line-height: 0.16rem;
                display: block;
                font-weight:400;
                text-align: center;
              }
            }
            .bestSellingSwiper {
              .swiper-container {
                padding-right: 0.6rem;
              }
              .swiper-wrapper {
                .swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                }
              }
              &+.totelPrice {
                background:rgba(255,255,255,1);
                box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              }
            }
          }
        }
      }
    }
    article{
      background: #fff;
      margin: 0.1rem 0.11rem 0;
      padding: 0.2rem 0.15rem 0.2rem;
      border-radius: 0.04rem;
      #afterEval {
        display: block;
        width: 100%;
        min-height: 1.43rem;
        border: none;
        outline: none;
        line-height: 0.18rem;
        font-size: 0.13rem;
        color: #333;
        &::placeholder {
          font-size: 0.13rem;
          color: #B0B0B0;
          line-height: 0.18rem;
        }
      }
      p {
        font-size: 0.11rem;
        color: #B0B0B0;
        text-align: right;
      }
      .evalPhotoBox {
        display: -o-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: flex;
        align-items: flex-end;
        -webkit-align-items: flex-end;
        -o--align-items: flex-end;
        -moz--align-items: flex-end;
        -ms--align-items: flex-end;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -o--flex-wrap: wrap;
        -moz--flex-wrap: wrap;
        -ms--flex-wrap: wrap;
        span {
          display: block;
          font-size: 0.11rem;
          color: #B0B0B0;
          margin-left: 0.1rem;
          margin-bottom: 0.08rem;
        }
      }
    }
    .contact {
      height: 0.45rem;
      background: #fff;
      margin: 0.1rem 0.11rem 0.55rem;
      padding: 0 0.15rem;
      display: flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      justify-content: space-between;
      -ms-justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -o-justify-content: space-between;
      border-radius: 0.04rem;
      .contactTitle {
        flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -o-flex: 1;
        b {
          display: block;
          font-size: 0.13rem;
          color: #000000;
          margin-right:0.08rem;
          float: left;
        }
        p {
          font-size:0.11rem;
          font-weight:400;
          color:rgba(176,176,176,1);
          line-height:0.16rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/after/afterEvaluation.vue